import React from 'react';
import { GlobalOutlined } from '@ant-design/icons';

interface SearchItem { title: string; url?: string; snippet?: string; }

function parse(text: string): SearchItem[] {
  const results: SearchItem[] = [];
  const lines = text.split('\n').filter(l => l.trim());
  for (const line of lines) {
    const m = line.match(/^Title:\s*(.+?)(?:\s+(?:Published:.*?)?\s*URL:\s*(https?:\/\/\S+))?\s*(.*)?$/i);
    if (m) {
      results.push({ title: m[1].trim(), url: m[2]?.trim(), snippet: m[3]?.trim() || undefined });
    } else if (!line.startsWith('Search results for')) {
      if (results.length > 0 && !results[results.length - 1].snippet) {
        results[results.length - 1].snippet = line.trim();
      } else if (line.trim()) {
        results.push({ title: line.trim() });
      }
    }
  }
  return results.length > 0 ? results : [{ title: text.slice(0, 100) }];
}

const UzyToolWebSearch: React.FC<{ content: string }> = ({ content }) => {
  const items = parse(content);
  return (
    <div className="chat-web-search-block">
      <div className="chat-web-search-header"><GlobalOutlined className="chat-web-search-icon" /><span>网络搜索</span></div>
      <div className="chat-web-search-results">
        {items.map((item, i) => (
          <div key={i} className="chat-web-search-item">
            {item.url
              ? <a href={item.url} target="_blank" rel="noopener noreferrer" className="chat-web-search-title">{item.title}</a>
              : <span className="chat-web-search-title">{item.title}</span>}
            {item.snippet && <div className="chat-web-search-snippet">{item.snippet}</div>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default UzyToolWebSearch;
